import React from "react";

/** StatCard with clinical status coloring. */
export default function StatCard({ label, value, sub, tone = "neutral", icon: Icon, testid, onClick }) {
  const toneClasses = {
    neutral: "text-foreground",
    good: "status-vacant",
    warn: "status-warn",
    crit: "status-critical",
    photo: "status-photo",
    primary: "text-primary",
  }[tone] || "text-foreground";

  const chipBg = {
    good: "bg-vacant",
    warn: "bg-warn",
    crit: "bg-critical",
    photo: "bg-photo",
  }[tone] || "bg-muted text-muted-foreground";

  return (
    <div className={`stat-tile ${onClick ? "cursor-pointer transition-transform hover:-translate-y-0.5 hover:ring-2 hover:ring-primary/30" : ""}`}
         data-testid={testid} onClick={onClick} role={onClick ? "button" : undefined} tabIndex={onClick ? 0 : undefined}
         onKeyDown={onClick ? (e) => { if (e.key === "Enter") onClick(); } : undefined}>
      <div className="flex items-start justify-between">
        <div className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
        {Icon && (
          <div className={`h-8 w-8 rounded-lg grid place-items-center ${chipBg}`}>
            <Icon size={16} />
          </div>
        )}
      </div>
      <div className={`mt-4 font-display font-semibold tabular text-4xl leading-none ${toneClasses}`}>
        {value}
      </div>
      {sub && <div className="mt-2 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
